import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/logo-date2022.svg'
import _imports_1 from '@/assets/images/banner_livestream.png'
import _imports_2 from '@/assets/images/bg-top_vrjmof.jpg'
import _imports_3 from '@/assets/images/top_conbadge.jpg'
import _imports_4 from '@/assets/images/logo-vrchat_ex.png'


const _withScopeId = n => (_pushScopeId("data-v-42fca944"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contents contents-top" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "logo-date" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "JAN 8-9 2022"
  })
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner-link-wrapper" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "banner-link" }, [
    /*#__PURE__*/_createElementVNode("a", {
      target: "_blank",
      href: "https://www.twitch.tv/vr_jmof/"
    }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        alt: "公式動画配信 / Official Livestream",
        width: "300"
      })
    ])
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_5 = { class: "news-inner" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = { class: "page-flexwrap" }
const _hoisted_9 = { class: "page-image" }
const _hoisted_10 = ["alt"]
const _hoisted_11 = { class: "page-flexinner" }
const _hoisted_12 = {
  href: "https://twitter.com/rrrro792",
  target: "_blank"
}
const _hoisted_13 = { class: "caution" }
const _hoisted_14 = { class: "contents contents-about_VRChat" }
const _hoisted_15 = { class: "box-wrap" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "VRChat",
  width: "245",
  height: "137.5"
}, null, -1))
const _hoisted_17 = { class: "box-inner" }
const _hoisted_18 = { class: "contents contents-about_JMoF" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheTopLogo = _resolveComponent("TheTopLogo")!
  const _component_ContentBox = _resolveComponent("ContentBox")!
  const _component_Heading = _resolveComponent("Heading")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LinkButton = _resolveComponent("LinkButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_TheTopLogo),
          _hoisted_2
        ]),
        _: 1
      }),
      _hoisted_3,
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-vrjmof-h')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrjmof-p_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrjmof-p_2')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrjmof-p_3')), 1),
          _hoisted_4
        ]),
        _: 1
      }),
      _createVNode(_component_ContentBox, { class: "content-box box-news" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-title')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('news-dt_6')), 1),
              _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('news-dd_5')), 1)
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('news-dt_5')), 1),
              _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('news-dd_4')), 1)
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('news-dt_4')), 1),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: "/access/instances" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-link_5')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-dd_2_1')), 1)
              ])
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('news-dt_3')), 1),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: "/program" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-link_4')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-dd_2_1')), 1)
              ]),
              _createElementVNode("dd", null, _toDisplayString(_ctx.$props.i18n.$text('news-dd_3')), 1)
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('news-dt_2')), 1),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: "/program/schedule" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-link_2')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-dd_2_1')), 1)
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: "/access" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-link_3')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-dd_2_1')), 1)
              ]),
              _createElementVNode("dd", null, [
                _createVNode(_component_router_link, { to: "/program/apply_avatar_poster" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-link_1')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-dd_2_2')), 1)
              ])
            ]),
            _createElementVNode("dl", null, [
              _createElementVNode("dt", null, _toDisplayString(_ctx.$props.i18n.$text('news-dt_1')), 1),
              _createElementVNode("dd", null, [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-dd_1_1')), 1),
                _hoisted_6,
                _createVNode(_component_router_link, { to: "/program/apply_avatar_poster" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-link_1')), 1)
                  ]),
                  _: 1
                }),
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('news-dd_1_2')), 1)
              ])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-badge-h')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-badge-p_1')) + " ", 1),
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.$props.i18n.$text('info-badge-p_2')), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: _imports_3,
                alt: _ctx.$props.i18n.$text('info-badge-alt_1'),
                width: "320"
              }, null, 8, _hoisted_10)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('info-badge-p_3')), 1),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-badge-p_4')), 1),
                _createElementVNode("a", _hoisted_12, _toDisplayString(_ctx.$props.i18n.$text('info-badge-link_1')), 1)
              ]),
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$props.i18n.$text('info-badge-caution_1')), 1)
            ])
          ]),
          _createVNode(_component_LinkButton, {
            href: "/downloads/VRJMoF2022_ConBadge.zip",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('info-badge-link_2')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_14, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-vrchat-h')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrchat-p_1')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-vrchat-p_2')), 1)
            ])
          ]),
          _createVNode(_component_LinkButton, {
            href: "https://hello.vrchat.com/",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-vrchat-link')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("section", _hoisted_18, [
      _createVNode(_component_ContentBox, { class: "content-box" }, {
        default: _withCtx(() => [
          _createVNode(_component_Heading, {
            class: "box-title",
            tag: "h2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-jmof-h')), 1)
            ]),
            _: 1
          }),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-jmof-p_1')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$props.i18n.$text('about-jmof-p_2')), 1),
          _createVNode(_component_LinkButton, {
            href: "https://www.jmof.jp/",
            "is-external": true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$props.i18n.$text('about-jmof-link')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ], 64))
}